import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { TComma, formatNumberWithCurrency } from '../../../../base/utils';
import { Box, Uniter } from '../../../../helbest';

const Summery = ({ login }) => (
  <Box className="cart-data-wrap-up">
    <div className="ws-100">
      <span>تعداد کالا</span>

      <span>
        {login.cart_data.total_quantity}
        <small className="mar-r-10">عدد</small>
      </span>
    </div>

    <div className="ws-100">
      <span>جمع کل سفارش</span>

      <Uniter className="" unit="تومان">
        {login.cart_data.total_amount}
      </Uniter>
    </div>

    <div className="ws-100">
      <span>تخفیف کالاها</span>

      <Uniter className="" unit="تومان">
        {login.cart_data.discount_amount}
      </Uniter>
    </div>

    <div className="ws-100">
      <span>اعتبار قابل استفاده</span>
      {formatNumberWithCurrency(TComma(login.cart_credit))}
    </div>

    <div className="cart-data-line-break" />

    <div className="ws-100">
      <span>مبلغ قابل پرداخت</span>

      <Uniter className="cart-data-price" unit="تومان">
        {login.cart_data.payable_amount}
      </Uniter>
    </div>
  </Box>
);

Summery.propTypes = {
  login: PropTypes.object
};

const mapStateToProps = (state) => ({
  login: state.Login
});

export default connect(mapStateToProps)(Summery);
